export default {
	name: 'uspSection',
	title: 'Value Proposition Section',
	type: 'object',
	fields: [
		{
			name: 'content',
			title: 'Content',
			type: 'array',
			of: [
				{
					type: 'block',
					styles: [{ title: 'Normal', value: 'normal' }],
					marks: {
						decorators: [
							{ title: 'Strong', value: 'strong' },
							{ title: 'Emphasis', value: 'em' },
						],
						annotations: [
							{
								name: 'color',
								title: 'Color',
								type: 'object',
								fields: [
									{
										name: 'value',
										title: 'Color',
										type: 'string',
										options: {
											list: [
												{ title: 'Yellow', value: 'yellow' },
												{ title: 'Black', value: 'black' },
											],
										},
									},
								],
							},
						],
					},
				},
			],
		},
	],
};
